import type { UserAlert } from "@/hooks/useUserAlerts";

// Application IDs are CUIDs (lowercase letters + digits, length 20-32, leading
// letter). We reject anything obviously not one — "TEST" seed values, numeric
// strings, whitespace, path separators — so the dev seed script and any future
// junk data can't push the user to /applications/TEST and trigger a false
// "Application not found".
export function isLikelyAppId(id: string): boolean {
  if (!id) return false;
  if (id.length < 16 || id.length > 36) return false;
  return /^[a-z][a-z0-9]+$/.test(id);
}

export function buildAlertLink(alert: UserAlert): string | null {
  const rawId = alert.related_entity_id;
  const id = rawId?.trim();
  const t = (alert.related_entity_type ?? "").toLowerCase();

  if (t === "support_ticket") return id ? `/helpdesk/ticket/${id}` : null;
  if (t === "merchant") return id ? `/merchants/${id}` : null;

  if (t.includes("application")) {
    return id && isLikelyAppId(id) ? `/applications/${id}` : null;
  }

  if (t === "message_thread") {
    const meta = (alert.metadata ?? {}) as Record<string, unknown>;
    if (meta.thread_type === "APPLICATION") {
      const appId = (meta.application_id ?? meta.pre_vet_application_id) as
        | string
        | undefined;
      return appId && isLikelyAppId(appId) ? `/applications/${appId}` : null;
    }
    if (meta.thread_type === "MERCHANT") return "/merchants";
  }

  return null;
}
